import React from 'react'
import { InElementSlot } from 'uiComponents/navigation/sectionTabsSlot'

export const PRODUCTS_TABLE_HEADER_SLOT_ID = 'products-table-header'

interface InProductsTableHeaderProps {
    children: React.ReactNode
}

export function InProductsTableHeader({ children }: InProductsTableHeaderProps) {
    return <InElementSlot slotId={PRODUCTS_TABLE_HEADER_SLOT_ID}>{children}</InElementSlot>
}

export default InProductsTableHeader
